export const DEFAULT_PAYMENT_GATEWAY =
  process.env.REACT_APP_PAYMENT_GATEWAY_DEFAULT;

export const PAYMENT_GATEWAY = {
  IN: process.env.REACT_APP_PAYMENT_GATEWAY_IN,
  // SG: process.env.REACT_APP_PAYMENT_GATEWAY_SG,
};
